import React from 'react';
import { MagnifyingGlass, Trash, X } from '@phosphor-icons/react';
import { MoonLoader } from 'react-spinners';
import { useAnalyzerReportsContext } from '@Context/AnalyzerReportsContext';
import { SelectedTicketEntry } from '@Models/types';

export const Sidebar: React.FC = () => {
  const {
    selectedTickets,
    setSelectedTickets,
    tagLoading,
    loading,
    searchTicket,
    setSearchTicket,
    handleTagTickets,
    setSelectedTicket,
  } = useAnalyzerReportsContext();

  const filteredSelectedTickets = Object.entries(selectedTickets).filter(
    ([, { ticket }]) =>
      ticket.ticket.reference_num
        .toLowerCase()
        .includes(searchTicket.toLowerCase())
  );
  const selectedTicketsFilteredObject: Record<string, SelectedTicketEntry> =
    Object.fromEntries(filteredSelectedTickets);

  return (
    <div className="flex h-full w-1/5 flex-col gap-1 rounded-xl border p-4 shadow-md">
      <span className="flex justify-between">
        <h2 className="text-lg font-bold">Tickets to Tag</h2>
        <button
          disabled={loading || tagLoading}
          onClick={handleTagTickets}
          className="rounded-md bg-primary-700 p-2 text-xs text-white disabled:bg-gray-400"
        >
          Tag Tickets
        </button>
      </span>
      <div className="mt-2 flex flex-row items-center gap-x-2 rounded-md border px-4 py-2">
        <MagnifyingGlass size={20} weight="bold" />
        <input
          type="text"
          className="w-full border-gray-300 font-inter text-xs focus:outline-none sm:text-sm"
          placeholder={`Search for tickets`}
          value={searchTicket}
          onChange={(e) => setSearchTicket(e.target.value)}
        />
        <X
          weight="bold"
          className="cursor-pointer hover:text-brandRed-500"
          onClick={() => setSearchTicket('')}
        />
      </div>
      <div className="flex flex-col rounded-md border p-2 shadow">
        <div
          className={`flex flex-row items-center justify-between text-sm font-semibold ${
            Object.keys(selectedTickets).length === 0
              ? 'text-gray-500'
              : 'text-primary-700'
          }`}
        >
          <label>Selected</label>
          <span className="flex flex-row items-center gap-x-1">
            <label data-testid="test-test-case-selected-count">
              {Object.keys(selectedTickets).length}
            </label>
            <Trash
              data-testid="test-test-case-clear-btn"
              weight="bold"
              className="cursor-pointer hover:text-brandRed-500"
              onClick={() => setSelectedTickets({})}
            />
          </span>
        </div>
      </div>
      <div className="my-2 border"></div>
      {tagLoading ? (
        <span className="flex h-full w-full flex-col items-center justify-center sm:gap-y-6 sm:p-5">
          <MoonLoader color="#071D49" size={100} />
          <span className="animate-pulse text-xs font-semibold tracking-wide text-gray-600 sm:text-sm">
            Fetching Reports
          </span>
        </span>
      ) : (
        <div className="flex flex-col gap-2 overflow-y-auto">
          {Object.values(selectedTicketsFilteredObject).map(
            ({ ticket, week }) => (
              <div
                key={ticket.ticket.reference_num}
                onClick={() => setSelectedTicket(ticket)}
                className="group flex cursor-pointer flex-row items-center justify-between rounded-md border p-2 text-xs shadow hover:bg-gray-50"
              >
                <div className="flex flex-col truncate">
                  <span className="truncate text-sm font-medium">
                    {ticket.ticket.reference_num}
                  </span>
                  <p className="text-[10px] text-gray-400">
                    Week: {week} • {ticket.ticket.reference_num.split('-')[0]}
                  </p>
                </div>
                <X
                  weight="bold"
                  size={16}
                  className="hover:text-brandRed-500"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedTickets((prev) => {
                      const copy = { ...prev };
                      delete copy[ticket.ticket.reference_num];
                      return copy;
                    });
                  }}
                />
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};
